/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Conversion_Pipeline_HintInputs */

const en_settings_v2_conversion_pipeline_hint = /** @type {(inputs: Settings_V2_Conversion_Pipeline_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staging only`)
};

const es_settings_v2_conversion_pipeline_hint = /** @type {(inputs: Settings_V2_Conversion_Pipeline_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo en staging`)
};

/**
* | output |
* | --- |
* | "Staging only" |
*
* @param {Settings_V2_Conversion_Pipeline_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_conversion_pipeline_hint = /** @type {((inputs?: Settings_V2_Conversion_Pipeline_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Conversion_Pipeline_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_conversion_pipeline_hint(inputs)
	return en_settings_v2_conversion_pipeline_hint(inputs)
});